import { render, staticRenderFns } from "./form_detail_novelties_component.vue?vue&type=template&id=5b9098c2&scoped=true"
import script from "./form_detail_novelties_component.vue?vue&type=script&lang=js"
export * from "./form_detail_novelties_component.vue?vue&type=script&lang=js"
import style0 from "./form_detail_novelties_component.vue?vue&type=style&index=0&id=5b9098c2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9098c2",
  null
  
)

export default component.exports